import { render, staticRenderFns } from "./reportData2.vue?vue&type=template&id=4f6de48c&"
import script from "./reportData2.vue?vue&type=script&lang=js&"
export * from "./reportData2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports